import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import ApiContent from '../api/ApiContent';
import CSwl from '../utils/alert';
import IconComponent from './Icons';
import { faEllipsisH, faBookmark as faBookmarkSolid } from '@fortawesome/free-solid-svg-icons';
import html2pdf from "html2pdf.js";
import './PostV2.scss'
import { faBookmark } from '@fortawesome/free-regular-svg-icons';
import { useClipboard } from 'use-clipboard-copy';
import { useTranslation } from "react-i18next";
import { arrayIncludesArray } from '../utils';
import { CheckBadgeIcon, TrashIcon } from '@heroicons/react/20/solid';
const PostContentGroupDetailNoEmployee =
    (
        { image, name, title, detail, page, item, isLike, isBookmark, totalLike, time, mode = "normal", comments = [], stateOrg = [], onDelete = () => { } }
    ) => {
        const { t, i18n } = useTranslation();
        const [spamFormError, setspamFormError] = useState("");
        const userState = useSelector((state) => state.user);
        const [imageFirst, setimageFirst] = useState('');
        const [coverImage, setCoverImage] = useState('');
        const [detailRemoveImage, setdetailRemoveImage] = useState(detail)
        const history = useHistory();
        const [like, setLike] = useState(totalLike);
        const [pIsLike, setPisLike] = useState(isLike);
        const [review, setReview] = useState(item.isReview ?? false);
        const [pIsBookMark, setPisBookmark] = useState(isBookmark);
        const [tags, settags] = useState([]);
        const [catalogs, setcatalogs] = useState([]);
        const [spam, setspam] = useState(false);
        const [options, setOptions] = useState(false);
        const [isModal, setisModal] = useState(false);
        const [spamValue, setspamValue] = useState('spam');
        const [spamNote, setspamNote] = useState('');
        const clipboard = useClipboard({ copiedTimeout: 800 });
        useEffect(() => {
            if (detail.includes('<img')) {
                // var str = detail;
                // var elem = document.createElement('div');
                // elem.style.display = 'none';
                // document.body.appendChild(elem);
                // elem.innerHTML = str;
                // setimageFirst(elem.querySelector('img').src);
                var content = detail.replace(/<img[^>]*>/g, "");
                setdetailRemoveImage(content);
            }
            if (item.cttagtJson != "[]") {
                let tags = JSON.parse(item.cttagtJson);
                settags(tags.map(x => x.Name));
            }
            if (item.ctcatagoryJson != "[]") {
                let catagory = JSON.parse(item.ctcatagoryJson);
                setcatalogs(catagory.map(x => x.Name));
            }
            if (item.coverimage && item.coverimage != "") {
                setCoverImage(item.coverimage);
            }
            return () => {

            }
        }, [])

        const func_like = async (e) => {
            // CSwl.SwalLoad();
            // e.stopPropagation();
            const result = await ApiContent.Like(item.id);
            if (result.status == 200) {
                if (result.data.statusLike) {
                    setLike(like + 1);
                    setPisLike(true);
                } else {
                    setLike(like - 1);
                    setPisLike(false);
                }
            }
            // CSwl.SwalClose();
        };


        const func_review = async (e) => {
            // CSwl.SwalLoad();
            // e.stopPropagation();
            const result = await ApiContent.Review(item.id);
            if (result.status == 200) {
                setReview(true)
            }
            // CSwl.SwalClose();
        };

        const func_bookmark = async (e) => {
            // CSwl.SwalLoad();
            e.stopPropagation();
            const result = await ApiContent.Bookmark(item.id);
            if (result.status == 200) {
                if (result.data.statusBookmark) {
                    setPisBookmark(true);
                } else {
                    setPisBookmark(false);
                }
            }
            // CSwl.SwalClose();
        };

        const func_edit = async (e) => {
            e.stopPropagation();
            history.push(`editcontent?c=${item.id}`);
        };

        const func_tag = async (e, item) => {
            e.stopPropagation();
            history.push(`/tag?q=${item}`);
        };

        const func_catalog = async (e, item) => {
            e.stopPropagation();
            history.push(`/catalog?q=${item}`);
        };

        const spamPost = async (e) => {
            e.stopPropagation();
            if (spamNote) {
                const result = await ApiContent.Spam({
                    ctid: item.id,
                    spamCode: spamValue,
                    spamNote: spamNote
                });
                if (result.status == 200) {
                    setspamValue('spam');
                    setspamNote("")
                    setisModal(false);
                    CSwl.SwalSuccess("รายงานโพสต์นี้เรียบร้อยแล้ว")
                }
            } else {
                setspamFormError("กรุณากรอกเหตุผลในการรายงาน")
            }


        }

        const _exportPdf = async (e) => {
            CSwl.SwalLoad();
            console.log(e);
            var element = e.target.nextElementSibling;

            element.style.display = "inherit";
            const opt = {
                margin: 20,
                filename: title,
                //image: { type: 'jpeg', quality: 1 },
                // html2canvas: { scale: 3 },
                html2canvas: { dpi: 192, letterRendering: true },
                //jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4' },
                image: { type: 'jpeg', quality: 0.98 },
                // filename: 'report.pdf',
                // html2canvas: { scale: 3 },
                jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
            };

            html2pdf().from(element).set(opt).toPdf().get('pdf').then((pdf) => {
                var totalPages = pdf.internal.getNumberOfPages();

                for (let i = 1; i <= totalPages; i++) {
                    // set footer to every page
                    pdf.setPage(i);
                    // set footer font
                    pdf.setFont("helvetica");
                    pdf.setFontSize(10);
                    pdf.setTextColor(150);
                    // this example gets internal pageSize just as an example to locate your text near the borders in case you want to do something like "Page 3 out of 4"
                    pdf.text(pdf.internal.pageSize.getWidth() - 30,
                        pdf.internal.pageSize.getHeight() - 10, 'YOUR TEXT GOES HERE!');

                    // you can add the line separator as an image, consult the docs below to properly set the place of the image
                    // pdf.addImage(img, 'png', 0, 0, 52, 23)
                }
            }).save();
            setTimeout(() => {
                element.style.display = "none";
                CSwl.SwalClose();
            }, 1000);
        }

        const _sharePdf = async (e) => {
            const url = `${window.location.origin}/contentDetail?id=${item.id}`;
            clipboard.copy(url);
        }



        const renderBookmarkButton = () => {
            return <div
                className="pl-2 is-flex is-align-items-center is-absolute is-right-15"
            >
                <div style={{ cursor: "pointer" }} onClick={(e) => {
                    func_bookmark(e);
                }}>
                    {pIsBookMark ? (
                        // <img
                        //     className="img-size"
                        //     src={process.env.PUBLIC_URL + "/images/firstPage/Like.png"}
                        //     alt="Like2"
                        //     width="16"
                        //     height="16"
                        // />
                        <IconComponent
                            className="icon-20x ml-3" color="#000"
                            icon={faBookmarkSolid}
                        />
                    ) : (
                        <IconComponent
                            className="icon-20x ml-3" color="#000"
                            icon={faBookmark}
                        />
                    )}
                </div>
                <div style={{ position: 'relative' }}>
                    <div className="cursor-pointer" onClick={(e) => {
                        e.stopPropagation();
                        setspam(!spam);
                    }}>
                        <IconComponent
                            className="icon-20x ml-3" color="#333"
                            icon={faEllipsisH}
                        />
                    </div>
                    {spam && <div
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        className="spam-container">
                        <ul>
                            <li className="cursor-pointer" onClick={(e) => {
                                e.stopPropagation();
                                setisModal(true);
                                setspamFormError("");
                                setspam(false);
                            }}>รายงานโพสต์นี้</li>
                        </ul>
                    </div>
                    }

                </div>
            </div>
        }

        const renderDeleteButton = () => {
            return <div
                className="pl-2 is-flex is-align-items-center is-absolute top-[15px] is-right-15"
            >
                <div style={{ position: 'relative' }}>
                    <div className="cursor-pointer" onClick={(e) => {
                        onDelete();
                    }}>
                        <TrashIcon className="icon-20x ml-3 !text-red-500" />
                    </div>
                </div>
            </div>
        }

        const renderOrg = (type) => {
            if (type == "bu" && item.bu) {
                const bu = stateOrg?.orgData.filter(x => item.bu.includes(x.departmentId));

                return <div className="">
                    <span className="is-size-7 tag !whitespace-normal"><span className="font-bold !whitespace-nowrap">BU :&nbsp;</span> {bu.map(x => x.organizationNameEn)?.join(',')}</span>
                </div>
            }
            else if (type == "subbu" && item.subbu) {
                const bu = stateOrg?.orgData.filter(x => item.subbu.includes(x.departmentId));

                return <div className="">
                    <span className="is-size-7 tag !whitespace-normal"><span className="font-bold !whitespace-nowrap">Sub BU :&nbsp;</span> {bu.map(x => x.organizationNameEn)?.join(',')}</span>
                </div>
            }
            else if (type == "company" && item.company) {
                const bu = stateOrg?.orgData.filter(x => item.company.includes(x.departmentId));

                return <div className="">
                    <span className="is-size-7 tag !whitespace-normal"><span className="font-bold !whitespace-nowrap">Company :&nbsp;</span>{bu.map(x => x.organizationNameEn)?.join(',')}</span>
                </div>
            }
            else if (type == "division" && item.division) {
                const bu = stateOrg?.orgData.filter(x => item.division.includes(x.departmentId));

                return <div className="">
                    <span className="is-size-7 tag !whitespace-normal"><span className="font-bold !whitespace-nowrap">Division :&nbsp;</span>{bu.map(x => x.organizationNameEn)?.join(',')}</span>
                </div>
            }
            else if (type == "sub_division" && item.sub_division) {
                const bu = stateOrg?.orgData.filter(x => item.sub_division.includes(x.departmentId));

                return <div className="">
                    <span className="is-size-7 tag !whitespace-normal"><span className="font-bold !whitespace-nowrap">Sub Division :&nbsp;</span>{bu.map(x => x.organizationNameEn)?.join(',')}</span>
                </div>
            }
            else if (type == "department" && item.department) {
                const bu = stateOrg?.orgData.filter(x => item.department.includes(x.departmentId));

                return <div className="">
                    <span className="is-size-7 tag !whitespace-normal"><span className="font-bold !whitespace-nowrap">Department :&nbsp;</span>{bu.map(x => x.organizationNameEn)?.join(', ')}</span>
                </div>
            }
            else if (type == "sub_department" && item.sub_department) {
                const bu = stateOrg?.orgData.filter(x => item.sub_department.includes(x.departmentId));

                return <div className="">
                    <span className="is-size-7 tag !whitespace-normal"><span className="font-bold !whitespace-nowrap">Sub Department :&nbsp;</span>{bu.map(x => x.organizationNameEn)?.join(',')}</span>
                </div>
            }
            else if (type == "section" && item.section) {
                const bu = stateOrg?.orgData.filter(x => item.section.includes(x.departmentId));

                return <div className="">
                    <span className="is-size-7 tag !whitespace-normal"><span className="font-bold !whitespace-nowrap">Section :&nbsp;</span>{bu.map(x => x.organizationNameEn)?.join(', ')}</span>
                </div>
            }
        }

        const checkPermission = () => {
            if (item.isSpecific == 1 && !userState.isEdit) {

                let isLocked = false;

                if (item.subbu && !userState.employee.departmentBuId != "") {
                    isLocked = true;
                }
                else if (item.bu && !item.bu.includes(userState.employee.departmentBuId)) {
                    isLocked = true;
                }

                if (item.subbu && !userState.employee.departmentBsg2Id != "") {
                    isLocked = true;
                }
                else if (item.subbu && !item.subbu.includes(userState.employee.departmentBsg2Id)) {
                    isLocked = true;
                }

                if (item.company && !userState.employee.departmentComId != "") {
                    isLocked = true;
                }
                else if (item.company && !item.company.includes(userState.employee.departmentComId)) {
                    isLocked = true;
                }

                if (item.division && !userState.employee.departmentDivId != "") {
                    isLocked = true;
                }
                else if (item.division && !item.division.includes(userState.employee.departmentDivId)) {
                    isLocked = true;
                }

                if (item.department && !userState.employee.departmentDepId != "") {
                    isLocked = true;
                }
                else if (item.department && !item.department.includes(userState.employee.departmentDepId)) {
                    isLocked = true;
                }


                if (item.section && !userState.employee.departmentSecId != "") {
                    isLocked = true;
                }
                else if (item.section && !item.section.includes(userState.employee.departmentSecId)) {
                    isLocked = true;
                }

                if (isLocked) {
                    return "post-locked";
                }
            }
        }

        const renderVerified = () => {
            const smeCategory = userState.employee.smeCategory;
            if (review == 1 && userState.isAdmin) {
                return <Badge label="Verified" type="verified" />;
            }
            else if (review == 1 && (smeCategory && arrayIncludesArray(smeCategory.split(','), catalogs))) {
                return <Badge label="Verified" type="verified" />;
            }
            else {
                <></>
            }
        }

        return (
            <>
                <div
                    id="subpost" className={`columns flex-1 block is-relative ${checkPermission()}`}>
                    {
                        onDelete && renderDeleteButton()
                    }
                    <div class={`column ${imageFirst || coverImage ? " is-8" : ""} pb-0`}>

                        <div id="post-share-pdf">
                            <div className="cursor-pointer" onClick={() => {
                                if (mode !== "edit") {
                                    window.open(`/contentDetail?id=${item.id}`, '_blank');
                                }
                            }}>
                                <div className="mt-3 ml-1">
                                    <div className='flex gap-2 items-center '>
                                        <h2 className="has-text-weight-bold is-size-4">{title}</h2>
                                        {
                                            renderVerified()
                                        }
                                    </div>

                                    <h3 className="description-short mt-4">
                                        <p dangerouslySetInnerHTML={{ __html: detailRemoveImage }}></p>
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 mb-4 d-flex flex-wrap" style={{ marginLeft: '-1rem' }}>
                            {catalogs && catalogs.map((item, index) => {
                                if (index > 4) {
                                    return false;
                                }
                                return (
                                    <div onClick={(e) => {
                                        func_catalog(e, item)
                                    }} className="pl-4 is-flex is-align-items-center cursor-pointer">
                                        <span className="is-size-7 tag">{item}</span>
                                    </div>
                                )
                            })}
                            {tags && tags.map((item, index) => {
                                if (index > 4) {
                                    return false;
                                }
                                return (
                                    <div onClick={(e) => {
                                        func_tag(e, item)
                                    }} className="pl-4 is-flex is-align-items-center cursor-pointer">
                                        <span className="is-size-7 tag">#{item}</span>
                                    </div>
                                )
                            })}
                        </div>
                        {
                            (item.isSpecific == 1 && stateOrg?.orgData) &&
                            <div className='flex flex-wrap gap-x-2 mt-2 gap-y-2  py-2'>
                                {
                                    renderOrg('bu')
                                }
                                {
                                    renderOrg('subbu')
                                }
                                {
                                    renderOrg('company')
                                }
                                {
                                    renderOrg('division')
                                }
                                {
                                    renderOrg('sub_division')
                                }
                                {
                                    renderOrg('department')
                                }
                                {
                                    renderOrg('sub_department')
                                }
                                {
                                    renderOrg('section')
                                }
                            </div>
                        }
                        {mode == "edit" && <div className="d-flex mt-2">
                            <button
                                onClick={(e) => {
                                    func_edit(e);
                                }}
                                className="button is-link is-rounded"
                            >
                                <div className="font-button">{t('text.edit')}</div>
                            </button>
                            {tags && tags.map((item, index) => {
                                return (
                                    <div
                                        className="pl-4 is-flex is-align-items-center">
                                        <span className="cursor-pointer is-size-7 tag">{item}</span>
                                    </div>
                                )
                            })}
                        </div>}


                    </div>
                    {coverImage &&
                        <div class="column d-flex is-align-items-center is-justify-content-center pt-5">
                            <img src={`${process.env.REACT_APP_IMAGE}${coverImage}`} alt="image_content" class="size-img" width="160" height="160"></img>
                        </div>
                    }
                    {(imageFirst && !coverImage) &&
                        <div class="column d-flex is-align-items-center is-justify-content-center pt-5">
                            <img src={imageFirst} alt="image_content" class="size-img" width="160" height="160"></img>
                        </div>
                    }

                </div>
            </>
        )
    }

function Badge({ label, type }) {
    const badgeStyles = {
        verified: 'bg-green-500 text-white px-2 py-1 rounded flex items-center gap-2 shadow-md',
        knowledgePath: 'bg-orange-500 text-white px-2 py-1 rounded flex items-center gap-2 shadow-md',
        knowledge: 'bg-blue-600 text-white px-2 py-1 rounded flex items-center gap-2 shadow-md',
    };

    const icon = {
        verified: (
            <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" width="16" height="16">
                <circle cx="12" cy="12" r="10" fill="white" />
                <path d="M9.75 12.75l1.5 1.5 4.5-4.5" stroke="green" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        knowledgePath: (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_1072_91" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                    <rect width="16" height="16" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1072_91)">
                    <path d="M12.6654 14C12.232 14 11.8431 13.875 11.4987 13.625C11.1543 13.375 10.9154 13.0556 10.782 12.6667H7.33203C6.5987 12.6667 5.97092 12.4056 5.4487 11.8833C4.92648 11.3611 4.66536 10.7333 4.66536 10C4.66536 9.26667 4.92648 8.63889 5.4487 8.11667C5.97092 7.59444 6.5987 7.33333 7.33203 7.33333H8.66536C9.03203 7.33333 9.34592 7.20278 9.60703 6.94167C9.86814 6.68056 9.9987 6.36667 9.9987 6C9.9987 5.63333 9.86814 5.31944 9.60703 5.05833C9.34592 4.79722 9.03203 4.66667 8.66536 4.66667H5.21536C5.07092 5.05556 4.82925 5.375 4.49036 5.625C4.15148 5.875 3.76536 6 3.33203 6C2.77648 6 2.30425 5.80556 1.91536 5.41667C1.52648 5.02778 1.33203 4.55556 1.33203 4C1.33203 3.44444 1.52648 2.97222 1.91536 2.58333C2.30425 2.19444 2.77648 2 3.33203 2C3.76536 2 4.15148 2.125 4.49036 2.375C4.82925 2.625 5.07092 2.94444 5.21536 3.33333H8.66536C9.3987 3.33333 10.0265 3.59444 10.5487 4.11667C11.0709 4.63889 11.332 5.26667 11.332 6C11.332 6.73333 11.0709 7.36111 10.5487 7.88333C10.0265 8.40556 9.3987 8.66667 8.66536 8.66667H7.33203C6.96536 8.66667 6.65148 8.79722 6.39036 9.05833C6.12925 9.31945 5.9987 9.63333 5.9987 10C5.9987 10.3667 6.12925 10.6806 6.39036 10.9417C6.65148 11.2028 6.96536 11.3333 7.33203 11.3333H10.782C10.9265 10.9444 11.1681 10.625 11.507 10.375C11.8459 10.125 12.232 10 12.6654 10C13.2209 10 13.6931 10.1944 14.082 10.5833C14.4709 10.9722 14.6654 11.4444 14.6654 12C14.6654 12.5556 14.4709 13.0278 14.082 13.4167C13.6931 13.8056 13.2209 14 12.6654 14ZM3.33203 4.66667C3.52092 4.66667 3.67925 4.60278 3.80703 4.475C3.93481 4.34722 3.9987 4.18889 3.9987 4C3.9987 3.81111 3.93481 3.65278 3.80703 3.525C3.67925 3.39722 3.52092 3.33333 3.33203 3.33333C3.14314 3.33333 2.98481 3.39722 2.85703 3.525C2.72925 3.65278 2.66536 3.81111 2.66536 4C2.66536 4.18889 2.72925 4.34722 2.85703 4.475C2.98481 4.60278 3.14314 4.66667 3.33203 4.66667Z" fill="white" />
                </g>
            </svg>
        ),
        knowledge: (
            <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" width="16" height="16">
                <rect x="6" y="5" width="12" height="14" rx="2" ry="2" stroke="white" strokeWidth="2" fill="none" />
                <path d="M9 8h6m-6 4h4" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
        ),
    };

    return (
        <div className={badgeStyles[type]}>
            {icon[type]}
            <span className="text-sm">{label}</span>
        </div>
    );
}

export default PostContentGroupDetailNoEmployee;